var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('CommissionsOverview'),_c('CommissionsPending'),_c('CommissionsPayable'),_c('CommissionsPaid'),(_vm.user && _vm.user.is_introducer_admin)?_c('RemittancePaid'):_vm._e(),_c('Attorneys')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }